import { Option } from "@shared/interfaces";

export enum TIME_LINE_CHUNKS {
  ONE_SECOND = "1 second",
  ONE_MINUTE = "1 minute",
  FIVE_MINUTES = "5 minutes",
  TEN_MINUTES = "10 minutes",
  THIRTY_MINUTES = "30 minutes",
  ONE_HOUR = "1 hour",
  THREE_HOURS = "3 hours",
  EIGHT_HOURS = "8 hours",
  TWELVE_HOURS = "12 hours",
  SEVEN_DAYS = "7 day",
}

export const TIME_LINE_CHUNKS_LIST = [
  { value: TIME_LINE_CHUNKS.ONE_SECOND, title: TIME_LINE_CHUNKS.ONE_SECOND },
  { value: TIME_LINE_CHUNKS.ONE_MINUTE, title: TIME_LINE_CHUNKS.ONE_MINUTE },
  { value: TIME_LINE_CHUNKS.FIVE_MINUTES, title: TIME_LINE_CHUNKS.FIVE_MINUTES },
  { value: TIME_LINE_CHUNKS.TEN_MINUTES, title: TIME_LINE_CHUNKS.TEN_MINUTES },
  { value: TIME_LINE_CHUNKS.THIRTY_MINUTES, title: TIME_LINE_CHUNKS.THIRTY_MINUTES },
  { value: TIME_LINE_CHUNKS.ONE_HOUR, title: TIME_LINE_CHUNKS.ONE_HOUR },
];

export enum ACTIONS {
  DELETE = "delete",
  LEAVE = "leave",
}

export enum FREQUENCY {
  TWICE_PER_WEEK = "Twice per week",
  DAILY = "Daily",
  MONTHLY = "Monthly",
  WEEKLY = "Weekly",
  BIWEEKLY = "Biweekly",
}

export enum MODAL_TYPES {
  CONFIRM = "CONFIRM",
  INFO = "INFO",
  SENSOR_DATA_RESTORE = "SENSOR_DATA_RESTORE",
  SELECT_SENSOR = "SELECT_SENSOR",
  CREATE_EDIT_FORM = "CREATE_EDIT_FORM",
  CREATE_MARKER_FORM = "CREATE_MARKER_FORM",
  CREATE_DOT_FORM = "CREATE_DOT_FORM",
  IMPORT_PATIENTS = "IMPORT_PATIENTS",
  IMPORT_RESULTS = "IMPORT_RESULTS",
  SELECT_FILE_FORM = "SELECT_FILE_FORM",
  INACTION_MODAL = "INACTION_MODAL",
  ALERT_READ_CONFIRM = "ALERT_READ_CONFIRM",
  ISSUE_READ_CONFIRM = "ISSUE_READ_CONFIRM",
  SENSOR_DATA_SESSION_SELECT_DATE_RANGE = "SENSOR_DATA_SESSION_SELECT_DATE_RANGE",
}

export enum OVERLAY_TYPES {
  CREATE_EDIT_USER = "CREATE_EDIT_USER",
  CREATE_EDIT_STATION = "CREATE_EDIT_STATION",
  VIEW_STATION_RAW_DATA = "VIEW_STATION_RAW_DATA",
  CREATE_EDIT_SENSOR = "CREATE_EDIT_SENSOR",
  CREATE_EDIT_PATIENT = "CREATE_EDIT_PATIENT",
  CREATE_EDIT_FORM = "CREATE_EDIT_FORM",
  CREATE_SENSOR_DATA_FILE_FORM = "CREATE_SENSOR_DATA_FILE_FORM",
  CREATE_SENSOR_DATA_RESTORING_REQUEST_FORM = "CREATE_SENSOR_DATA_RESTORING_REQUEST_FORM",
  CREATE_SENSOR_DATA_SESSION_FORM = "CREATE_SENSOR_DATA_SESSION_FORM",
  CREATE_EDIT_ALERT = "CREATE_EDIT_ALERT",
  ALERT_NOTIFICATIONS_LIST = "ALERT_NOTIFICATIONS_LIST",
  STATION_ISSUES_LIST = "STATION_ISSUES_LIST",
}

export enum SIDEBAR_TYPES {
  PATIENT_DETAILS = "PATIENT_DETAILS",
  SESSION_DETAILS = "SESSION_DETAILS",
  NONE = "NONE",
}

export enum STATUS {
  ALL = "",
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}

export enum INPUT_TYPES {
  PASSWORD = "password",
  TEXT = "text",
}

export enum GENDER {
  MALE = "Male",
  FEMALE = "Female",
}

export const AUTOPLAY_INTERVAL = 1000;
export const MAX_DOTS = "1000";
export const DEFAULT_DOTS = "300";

export const DEFAULT_INTERVAL_OPTION: Option<number> = {
  label: "5 sec",
  value: 5,
};

export const FILE_INTERVAL_OPTIONS: Option<number>[] = [
  DEFAULT_INTERVAL_OPTION,
  {
    label: "30 sec",
    value: 30,
  },
  {
    label: "5 min",
    value: 5 * 60,
  },
  {
    label: "10 min",
    value: 10 * 60,
  },
];

export const MONGO_INTERVAL_OPTIONS: Option<number>[] = [
  ...FILE_INTERVAL_OPTIONS,
  {
    label: "15 min",
    value: 15 * 60,
  },
  {
    label: "30 min",
    value: 30 * 60,
  },
  {
    label: "45 min",
    value: 45 * 60,
  },
  {
    label: "1 hrs",
    value: 60 * 60,
  },
];

export const TRACKING_PARAMETER_SETTINGS = [
  {
    label: "Stable Period",
    value: "Stable Period",
  },
  { label: "Set up parameters manually", value: "Manual Parameters" },
];

export enum TIMEZONE {
  EUROPE = "Europe/London",
  UTC = "UTC",
}

export enum DATE_FORMAT {
  GENERAL = "YYYY-MM-DD HH:mm:ss",
  DATE_PICKER = "yyyy-MM-dd HH:mm:ss",
  PICKER = "yyyy-MM-dd",
  CHART = "MM/DD/YYYY",
  TIME = "HH:mm:ss",
}

export const USER_SESSION_INTERVAL_FREQUENCY_MINUTES = 5;
export const STANDARD_DIFFERENCE_IN_DAYS = 13;

export enum SENSOR_SIGNAL_TYPE {
  HR = "hr",
  RR = "rr",
}

export enum QUERY_EXECUTION_STATUS_ATHENA {
  QUEUED = "QUEUED",
  RUNNING = "RUNNING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

export enum ENV {
  DEV = "dev",
  QA = "qa",
  STAGE = "stage",
  PROD = "production",
}

export const TEST_ENV = [ENV.DEV, ENV.QA, ENV.STAGE];
